import * as React from "react";
import styled from "../../styled";
/** Grey rounded card holding the numbered step tracker (Client Order Tracking UI). */
export const TimelineWrapper = styled("div") `
	background: #f1f4f7;
	border-radius: 8px;
	margin: 16px;
	padding: 44px 16px 16px 16px;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: space-between;
`;
export const TimelineConnector = styled("div") `
	height: 2px;
	width: 100%;
	background: #a4a7ae;
	${({ active, theme }) => (active ? `background: ${theme.colors.primary};` : "")}
`;
export const TimelineMarker = styled("div") `
	position: relative;
	height: 24px;
	width: 24px;
	min-width: 24px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: 700;
	line-height: 1;
	color: #fff;
	background: ${({ active, theme }) => (active ? theme.colors.primary : "#a4a7ae")};
	.tl-label {
		color: ${({ active }) => (active ? "#0c202a" : "#717680")};
	}
`;
export const TimelineMarkerLabel = styled("div") `
	position: absolute;
	bottom: calc(100% + 10px);
	left: 50%;
	transform: translateX(-50%);
	font-size: 12px;
	font-weight: 600;
	line-height: 18px;
	white-space: nowrap;
	text-align: center;
	&.tl-first {
		left: 0;
		transform: none;
		text-align: left;
	}
	&.tl-last {
		left: auto;
		right: 0;
		transform: none;
		text-align: right;
	}
`;
export class Timeline extends React.Component {
    render() {
        const { stages, current } = this.props;
        const currentIndex = stages.findIndex((s) => s.id === current);
        const lastIndex = stages.length - 1;
        return (React.createElement(TimelineWrapper, null, stages.map((s, i) => {
            const posClass = i === 0 ? "tl-first" : i === lastIndex ? "tl-last" : "";
            return [
                i === 0 ? null : (React.createElement(TimelineConnector, { key: `${i}-connector`, active: i <= currentIndex })),
                (React.createElement(TimelineMarker, { key: `${i}-marker`, active: i <= currentIndex, current: i === currentIndex },
                    React.createElement(TimelineMarkerLabel, { className: `tl-label ${posClass}`.trim() }, s.label),
                    i + 1)),
            ];
        })));
    }
}
//# sourceMappingURL=index.js.map